import { useActiveProjectId } from "@/lib/hooks/useActiveProjectId";
import { useMessageStore } from "@/state/stores";

/**
 * Hook to determine if the user is in a new project state.
 * A new project is when there are no messages and no active project ID.
 */
export function useIsNewProject() {
  const hasMessages = useMessageStore((state) => state.messages.length === 0);
  const activeProjectId = useActiveProjectId();

  return hasMessages && !activeProjectId;
}
